module.exports = __webpack_public_path__ + "static/media/healthBubble.70daa7d5.png";